module.exports = __webpack_public_path__ + "img/群雄逐鹿.226cd04d.png";